import { c as _c } from "react/compiler-runtime";
import type { VaultRedacted } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
type VaultRedactedEventHeaderProps = {
  data: VaultRedacted;
};
const VaultRedactedEventHeader = t0 => {
  const $ = _c(16);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.vaultRedactedEvent"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t(_temp2);
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="flex items-center gap-1 text-label-2 text-warning">{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== data.imagesOnly || $[8] !== t) {
    t5 = data.imagesOnly ? t(_temp3) : t(_temp4);
    $[7] = data.imagesOnly;
    $[8] = t;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t5) {
    t6 = <p className="text-body-2 text-tertiary text-warning">{t5}</p>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t4 || $[14] !== t6) {
    t7 = <div className="flex justify-start items-center gap-1 flex-wrap" aria-label={t2}>{t4}{t6}</div>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default VaultRedactedEventHeader;
function _temp($) {
  return $.ariaLabel;
}
function _temp2($_0) {
  return $_0.title;
}
function _temp3($_1) {
  return $_1.imagesDescription;
}
function _temp4($_2) {
  return $_2.description;
}